import { DefaultTheme } from 'styled-components';

import sizes from './sizes';
import colors from './colors';
import shadows from './shadows';
import dark from './variant/dark';
import light from './variant/light';
import breakpoints from './breakpoints';
import transitions from './transitions';
import device from './device';
import general from './general';

const commonThemeProps = {
  fontFamily: "'Inter', sans-serif;",
  palette: {
    ...colors,
  },
  transitions: {
    ...transitions,
  },
  sizes: {
    ...sizes,
  },
  shadows: {
    ...shadows,
  },
  general: {
    ...general,
  },
  breakpoints: {
    ...breakpoints,
  },
  device: {
    ...device,
  },
  fonts: {
    UrbaneDemiBold: "'Urbane-DemiBold', sans-serif",
    UrbaneMedium: "'Urbane-Medium', sans-serif",
  },
};

const theme: { light: DefaultTheme; dark: DefaultTheme } = {
  light: {
    ...commonThemeProps,
    colors: {
      ...light,
    },
  },
  dark: {
    ...commonThemeProps,
    colors: {
      ...dark,
    },
  },
};

export default theme;
